(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7616],{

/***/ 47805:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signup",
      function () {
        return __webpack_require__(85301);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ Banner; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41796);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57922);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87357);
/* harmony import */ var _mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10224);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86010);







var useStyles = (0,_mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(theme) {
    var _obj;
    return {
        root: {},
        content: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, theme.typography.body2), (_obj = {
            backgroundColor: theme.colors.softGrey,
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            justifyContent: "center",
            lineHeight: 1.3,
            minHeight: 42,
            padding: theme.spacing(),
            textAlign: "center"
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, theme.breakpoints.up("sm"), {
            padding: theme.spacing(1, 2)
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "& strong", {
            display: "inline-block",
            margin: theme.spacing(0, 0.5),
            padding: theme.spacing(0, 0.5),
            borderRadius: theme.spacing(0.5),
            backgroundColor: theme.colors.warning.main,
            fontWeight: theme.typography.fontWeightBold
        }), _obj)),
        big: {
            fontSize: 16
        },
        small: {},
        success: {
            backgroundColor: (0,_mui_material__WEBPACK_IMPORTED_MODULE_5__/* .lighten */ .$n)(theme.palette.success.light, 0.8),
            color: (0,_mui_material__WEBPACK_IMPORTED_MODULE_5__/* .darken */ ._j)(theme.palette.success.dark, 0.5),
            "& a": {
                color: (0,_mui_material__WEBPACK_IMPORTED_MODULE_5__/* .darken */ ._j)(theme.palette.success.dark, 0.5)
            }
        },
        info: {
            backgroundColor: (0,_mui_material__WEBPACK_IMPORTED_MODULE_5__/* .lighten */ .$n)(theme.palette.info.main, 0.85),
            color: (0,_mui_material__WEBPACK_IMPORTED_MODULE_5__/* .darken */ ._j)(theme.palette.info.main, 0.5),
            "& a": {
                color: (0,_mui_material__WEBPACK_IMPORTED_MODULE_5__/* .darken */ ._j)(theme.palette.info.main, 0.5)
            }
        },
        warning: {
            backgroundColor: theme.palette.warning.light,
            color: theme.palette.warning.dark,
            "& a": {
                color: theme.palette.warning.dark
            }
        },
        error: {
            backgroundColor: (0,_mui_material__WEBPACK_IMPORTED_MODULE_5__/* .lighten */ .$n)(theme.palette.error.light, 0.9),
            color: theme.palette.error.dark,
            "& a": {
                color: theme.palette.error.dark
            }
        },
        dark: {
            backgroundColor: "#2f2e41",
            color: theme.palette.common.white,
            "& a": {
                color: theme.colors.logo.shrimp
            }
        }
    };
}, {
    classNamePrefix: "Banner"
});
var Banner = function(param) {
    var className = param.className, extClasses = param.classes, children = param.children, inProp = param.in, _size = param.size, size = _size === void 0 ? "small" : _size, _variant = param.variant, variant = _variant === void 0 ? "default" : _variant;
    var classes = useStyles({
        classes: extClasses
    });
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        in: inProp,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.root, className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.content, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, classes.big, size === "big"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, classes.small, size === "small"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, classes.dark, variant === "dark"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, classes.success, variant === "success"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, classes.info, variant === "info"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, classes.warning, variant === "warning"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, classes.error, variant === "error"), _obj)),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                children: children
            })
        })
    });
};


/***/ }),

/***/ 28505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ oidc_GoogleButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@mui/styles/makeStyles/makeStyles.js + 26 modules
var makeStyles = __webpack_require__(10224);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/oidc/GoogleButton/img/icon.svg
var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgIcon(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 48 48",
    className: "icon_svg__abcRioButtonSvg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fill: "#EA4335",
    d: "M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#4285F4",
    d: "M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#FBBC05",
    d: "M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    fill: "#34A853",
    d: "M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
  })), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h48v48H0z"
  })));
}
/* harmony default export */ var icon = (SvgIcon);
;// CONCATENATED MODULE: ./src/components/oidc/GoogleButton/index.tsx








var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: {
            backgroundColor: "#FFF",
            borderRadius: 26,
            boxShadow: "0 2px 4px 0 rgba(0, 0, 0, .1)",
            color: "#262626",
            cursor: "pointer",
            display: "flex",
            justifyContent: "center",
            userSelect: "none",
            transition: theme.transitions.create([
                "box-shadow"
            ], {
                easing: theme.transitions.easing.easeInOut,
                duration: "0.2s"
            }),
            "&:hover": {
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, .1)"
            }
        },
        icon: {
            flexGrow: 0,
            padding: 15,
            backgroundColor: "#fff",
            borderRadius: 26
        },
        iconSmall: {
            flexGrow: 0,
            padding: 8,
            backgroundColor: "#fff"
        },
        svg: {
            display: "block",
            height: 18,
            width: 18
        },
        label: {
            fontSize: "16px",
            fontWeight: theme.typography.fontWeightMedium,
            lineHeight: "48px",
            paddingRight: 15
        },
        small: {
            fontSize: "0.9rem",
            fontWeight: 700,
            lineHeight: "30px",
            letterSpacing: "0.21px"
        },
        dark: {
            color: "#fff",
            backgroundColor: "#4285F4",
            border: "1px solid transparent",
            maxWidth: "max-content",
            "&:hover": {
                backgroundColor: "#4285f4"
            },
            "&:active": {
                color: "#fff",
                backgroundColor: "#3367d6"
            },
            "& $label": {
                paddingLeft: 15,
                paddingRight: 24
            }
        },
        disabled: {
            color: (0,colorManipulator/* lighten */.$n)("#262626", 0.25),
            backgroundColor: (0,colorManipulator/* darken */._j)("#FFF", 0.25),
            pointerEvents: "none",
            "&:hover": {
                color: (0,colorManipulator/* lighten */.$n)("#262626", 0.25),
                backgroundColor: (0,colorManipulator/* darken */._j)("#FFF", 0.25),
                boxShadow: "none"
            },
            "&:active": {
                color: (0,colorManipulator/* lighten */.$n)("#262626", 0.25),
                backgroundColor: (0,colorManipulator/* darken */._j)("#FFF", 0.25)
            }
        }
    };
});
var GoogleButton = function(param) {
    var _label = param.label, label = _label === void 0 ? "Log in with Google" : _label, disabled = param.disabled, dark = param.dark, className = param.className, onClick = param.onClick, small = param.small;
    var classes = useStyles();
    var handleClick = function(e) {
        if (disabled) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (onClick) onClick(e);
    };
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        "aria-label": label,
        onClick: handleClick,
        className: (0,clsx_m/* default */.Z)(classes.root, (_obj = {}, (0,_define_property/* default */.Z)(_obj, classes.dark, dark), (0,_define_property/* default */.Z)(_obj, classes.disabled, disabled), _obj), className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: (0,clsx_m/* default */.Z)(classes.icon, "oidc-google-button-icon", (0,_define_property/* default */.Z)({}, classes.iconSmall, small)),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon, {
                    className: classes.svg
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (0,clsx_m/* default */.Z)(classes.label, "oidc-google-button-label", (0,_define_property/* default */.Z)({}, classes.small, small)),
                children: label
            })
        ]
    });
};
/* harmony default export */ var oidc_GoogleButton = (GoogleButton);


/***/ }),

/***/ 85301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ signup; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/styles/makeStyles/makeStyles.js + 26 modules
var makeStyles = __webpack_require__(10224);
// EXTERNAL MODULE: ./src/AppTheme.ts + 1 modules
var AppTheme = __webpack_require__(73916);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/Hidden/Hidden.js + 4 modules
var Hidden = __webpack_require__(50456);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js + 1 modules
var List = __webpack_require__(78462);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItem/ListItem.js + 2 modules
var ListItem = __webpack_require__(9875);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemIcon/ListItemIcon.js
var ListItemIcon = __webpack_require__(48885);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(59334);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/CheckRounded.js
var CheckRounded = __webpack_require__(65189);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(34557);
// EXTERNAL MODULE: ./src/components/oidc/GoogleButton/index.tsx + 1 modules
var GoogleButton = __webpack_require__(28505);
// EXTERNAL MODULE: ./src/consts/storageKeys.ts
var storageKeys = __webpack_require__(14101);
// EXTERNAL MODULE: ./src/context/UserContext.tsx
var UserContext = __webpack_require__(59484);
// EXTERNAL MODULE: ./src/hooks/useOurRouter.ts
var useOurRouter = __webpack_require__(52581);
// EXTERNAL MODULE: ./src/img/logo-on-black.svg
var logo_on_black = __webpack_require__(49224);
// EXTERNAL MODULE: ./src/img/logo-on-blurple.svg
var logo_on_blurple = __webpack_require__(15165);
// EXTERNAL MODULE: ./src/reclaim-api/index.ts + 12 modules
var reclaim_api = __webpack_require__(75739);
// EXTERNAL MODULE: ./src/utils/local-storage.ts
var local_storage = __webpack_require__(91325);
// EXTERNAL MODULE: ./src/utils/platform.ts
var platform = __webpack_require__(94423);
// EXTERNAL MODULE: ./src/utils/router.ts
var utils_router = __webpack_require__(63429);
// EXTERNAL MODULE: ./src/layouts/LandingLayout.tsx + 3 modules
var LandingLayout = __webpack_require__(29203);
;// CONCATENATED MODULE: ./src/layouts/pages/SignupLayout.tsx

























var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj, _obj1, _obj2, _obj3, _obj4, _obj5;
    return {
        layout: (0,_define_property/* default */.Z)({
            backgroundColor: theme.colors.logo.darkness,
            color: theme.colors.white
        }, theme.breakpoints.up("md"), {
            alignItems: "center",
            display: "flex",
            flexDirection: "row-reverse",
            height: "100%",
            justifyContent: "flex-end",
            padding: theme.spacing(0, 3)
        }),
        gridContainerz: (0,_define_property/* default */.Z)({
            minHeight: "50vh",
            padding: theme.spacing(8, 2),
            textAlign: "center",
            width: "100vw"
        }, theme.breakpoints.up("md"), {
            minHeight: 0,
            width: "auto"
        }),
        form: (_obj = {
            backgroundColor: theme.palette.primary.main
        }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
            boxShadow: "0 32px 32px -16px black",
            padding: theme.spacing(7, 4),
            textAlign: "center"
        }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("lg"), {
            justifyContent: "flex-start"
        }), (0,_define_property/* default */.Z)(_obj, "& $wrapper", {
            maxWidth: 400
        }), _obj),
        text: (_obj1 = {
            padding: theme.spacing(8, 4)
        }, (0,_define_property/* default */.Z)(_obj1, theme.breakpoints.up("md"), {
            maxWidth: "50vw",
            padding: 0,
            textAlign: "left",
            width: "50vw"
        }), (0,_define_property/* default */.Z)(_obj1, theme.breakpoints.up("lg"), {
            justifyContent: "flex-end",
            paddingRight: theme.spacing(10)
        }), (0,_define_property/* default */.Z)(_obj1, "& $wrapper", {
            maxWidth: 480
        }), _obj1),
        wrapper: {
            width: "100%"
        },
        logoBtn: (_obj2 = {
            display: "inline-block",
            margin: theme.spacing(0, "auto", 2),
            padding: 0
        }, (0,_define_property/* default */.Z)(_obj2, theme.breakpoints.up("md"), {
            margin: theme.spacing(0, 0, 2)
        }), (0,_define_property/* default */.Z)(_obj2, "&:hover", {
            background: "transparent"
        }), (0,_define_property/* default */.Z)(_obj2, "& svg", {
            height: 24,
            width: 120
        }), _obj2),
        googleBtn: {
            margin: "0 auto",
            maxWidth: 360,
            transform: "scale(1)",
            transition: "transform .2s ease",
            width: "100%",
            "&:hover": {
                transform: "scale(1.02)"
            }
        },
        body: {
            margin: theme.spacing(4, 0)
        },
        signupText: {
            marginTop: theme.spacing(4),
            "& a": {
                color: "inherit",
                textDecoration: "underline"
            }
        },
        o365Callout: (_obj3 = {
            backgroundColor: "rgba(0, 0, 0, .08)",
            borderRadius: 8,
            margin: theme.spacing(5, "auto", 0),
            padding: theme.spacing(2)
        }, (0,_define_property/* default */.Z)(_obj3, theme.breakpoints.up("md"), {
            margin: theme.spacing(5, 0, 0)
        }), (0,_define_property/* default */.Z)(_obj3, "& a", {
            color: "inherit",
            textDecoration: "underline"
        }), _obj3),
        heading: {
            fontWeight: theme.typography.fontWeightBold
        },
        benefits: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.typography.body2), (_obj4 = {
            margin: theme.spacing(0, "auto", 2),
            maxWidth: "max-content"
        }, (0,_define_property/* default */.Z)(_obj4, theme.breakpoints.up("md"), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.typography.body1), {
            margin: theme.spacing(0, 0, 3)
        })), (0,_define_property/* default */.Z)(_obj4, "& .MuiListItemText-root", {
            margin: 0
        }), _obj4)),
        checkIcon: {
            color: theme.colors.logo.corn,
            minWidth: 32
        },
        boldText: {
            fontWeight: theme.typography.fontWeightBold
        },
        companyLogos: (_obj5 = {
            alignItems: "center",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            margin: "0 auto",
            maxWidth: 400,
            opacity: 0.8
        }, (0,_define_property/* default */.Z)(_obj5, theme.breakpoints.up("md"), {
            justifyContent: "flex-start",
            margin: 0
        }), (0,_define_property/* default */.Z)(_obj5, "& *", {
            height: 27,
            margin: theme.spacing(1.5, 2, 0, 0)
        }), _obj5),
        indeedLogo: {
            padding: theme.spacing(0.5, 0)
        },
        logoPadding: {
            padding: theme.spacing(0.25, 0)
        },
        lighten: {
            opacity: 0.8
        }
    };
}, {
    index: 2,
    name: "SignupLayout"
});
var SignupLayout = function(param) {
    var title = param.title, displayLoginButton = param.displayLoginButton, officeNotice = param.officeNotice, children = param.children;
    var ref, ref1;
    var theme = (0,useTheme/* default */.Z)();
    var classes = useStyles(theme);
    var medium = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("lg"));
    var router = (0,useOurRouter/* useOurRouter */.ED)();
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,UserContext/* useUserContext */.SE)(), 1), ref3 = ref2[0], user = ref3.user, isAuthenticated = ref3.isAuthenticated, status = ref3.status;
    var ref4 = (0,react.useState)(), error = ref4[0], setError = ref4[1];
    var urlParams = (0,react.useMemo)(function() {
        return new URLSearchParams((0,platform/* browser */.Xh)().isBrowser ? window.location.search : "");
    }, []);
    (0,react.useEffect)(function() {
        var ref;
        if (!((ref = router.query) === null || ref === void 0 ? void 0 : ref.reason)) return;
        var reason = router.query.reason;
        setError("USER_DISABLED" === reason ? "Calendar for this email address is linked to another account. Please sign in using your other Google login." : "User not authorized.");
    }, [
        (ref = router.query) === null || ref === void 0 ? void 0 : ref.reason
    ]);
    // Redirect if user is already authenticated
    (0,react.useEffect)(function() {
        var ref;
        if (!router.isReady || !isAuthenticated) return;
        (0,local_storage/* removeLocalStorage */.dZ)(storageKeys/* LOCAL_STORAGE_AUTH_REAUTH */.Vt);
        (0,local_storage/* removeLocalStorage */.dZ)(storageKeys/* LOCAL_STORAGE_AUTH_ATTEMPTS */.aJ);
        var slackTeamId = urlParams.get("slackTeamId");
        var slackUserId = urlParams.get("slackUserId");
        // the check for "://" prevents arbitrary redirection (Open Redirect)
        var oauthRedirect = (ref = router.query.state) === null || ref === void 0 ? void 0 : ref.redirect;
        var redirect = !!oauthRedirect && !oauthRedirect.includes("://") ? oauthRedirect : (0,local_storage/* getSessionStorage */.G)(storageKeys/* LOCAL_STORAGE_AUTH_REDIRECT */.I7);
        if (redirect) {
            (0,local_storage/* removeSessionStorage */.VV)(storageKeys/* LOCAL_STORAGE_AUTH_REDIRECT */.I7);
        }
        // connect slack user
        if (slackUserId && slackTeamId) {
            reclaim_api/* reclaim.slack.link */.Tz.slack.link(slackUserId, slackTeamId).catch(function(reason) {
                if (404 === reason.status) {
                    console.log("Slack user not found, redirecting", reason);
                    reclaim_api/* reclaim.slack.authRedirect */.Tz.slack.authRedirect(slackTeamId);
                    return;
                } else {
                    console.error("Failed to link slack user", reason);
                }
            });
        }
        var pathname = (0,utils_router/* getUserOnboardingPath */.gi)("welcome");
        if (user === null || user === void 0 ? void 0 : user.onboarded) {
            if (redirect) pathname = redirect;
            else if (medium) pathname = "/stats";
            else pathname = "planner";
        }
        void router.push({
            pathname: pathname,
            query: router.query
        });
    }, [
        isAuthenticated,
        medium,
        router,
        urlParams,
        user === null || user === void 0 ? void 0 : user.onboarded
    ]);
    var handleClick = (0,react.useCallback)(function(provider) {
        var ref;
        (0,local_storage/* removeLocalStorage */.dZ)(storageKeys/* LOCAL_STORAGE_AUTH_REAUTH */.Vt);
        (0,local_storage/* removeLocalStorage */.dZ)(storageKeys/* LOCAL_STORAGE_AUTH_ATTEMPTS */.aJ);
        var storedUser = (0,local_storage/* getLocalStorage */.$o)(storageKeys/* LOCAL_STORAGE_AUTH_USER */.kG);
        var ref1 = (0,local_storage/* getLocalStorage */.$o)(storageKeys/* LOCAL_STORAGE_AUTH_REF */.ZB);
        var utm = (0,local_storage/* getLocalStorage */.$o)(storageKeys/* LOCAL_STORAGE_AUTH_UTM */.$K);
        var slackTeamId = urlParams.get("slackTeamId");
        var slackUserId = urlParams.get("slackUserId");
        var invite = urlParams.get("invite");
        // the check for "://" prevents arbitrary redirection (Open Redirect)
        var oauthRedirect = (ref = router.query.state) === null || ref === void 0 ? void 0 : ref.redirect;
        var redirect = "".concat(!!oauthRedirect && !oauthRedirect.includes("://") ? oauthRedirect : (0,local_storage/* getSessionStorage */.G)(storageKeys/* LOCAL_STORAGE_AUTH_REDIRECT */.I7, "/")).concat(!!invite ? "?invite=1" : "");
        (0,local_storage/* removeSessionStorage */.VV)(storageKeys/* LOCAL_STORAGE_AUTH_REDIRECT */.I7);
        var state = {
            flow: "default",
            redirect: redirect,
            slackTeamId: slackTeamId,
            slackUserId: slackUserId,
            ref: ref1,
            utm: utm
        };
        reclaim_api/* reclaim.users.authRedirect */.Tz.users.authRedirect(provider, storedUser === null || storedUser === void 0 ? void 0 : storedUser.email, state);
    }, [
        (ref1 = router.query.state) === null || ref1 === void 0 ? void 0 : ref1.redirect,
        urlParams
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingLayout/* default */.Z, {
        title: title,
        loading: [
            "init",
            "loading"
        ].includes(status) || !!isAuthenticated,
        hideNav: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            className: classes.layout,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    container: true,
                    className: (0,clsx_m/* default */.Z)(classes.gridContainerz, classes.form),
                    justifyContent: "center",
                    alignItems: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: classes.wrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                                mdUp: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                    className: classes.logoBtn,
                                    component: Link/* Link */.r,
                                    href: !!user ? "/" : "//reclaim.ai",
                                    size: "medium",
                                    "aria-label": "reclaim.ai",
                                    disableTouchRipple: true,
                                    disableRipple: true,
                                    disableFocusRipple: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo_on_blurple/* default */.Z, {})
                                })
                            }),
                            children,
                            !!displayLoginButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleButton/* default */.Z, {
                                label: "Continue with Google",
                                onClick: function() {
                                    return handleClick("google");
                                },
                                className: classes.googleBtn
                            }),
                            !!error && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: "body1",
                                color: "error",
                                className: classes.body,
                                children: [
                                    error,
                                    "\xa0 If you believe this to be an error, please contact support."
                                ]
                            }),
                            !!officeNotice && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: "body2",
                                className: classes.o365Callout,
                                children: [
                                    "At this time, Reclaim only works on Google Calendar. Interested in Office 365?",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                        href: "mailto:hello@reclaim.ai?subject=Re:%20Office%20365%20Support%20for%20Reclaim&body=Hi%20Reclaim%20Team!%0D%0A%0D%0AI'm%20an%20Office%20365%20user%20and%20would%20love%20to%20stay%20updated%20when%20Reclaim%20works%20for%20O365%20calendars.%0D%0A%0D%0AThanks!",
                                        children: "Let\xa0us\xa0know"
                                    })
                                ]
                            }),
                            !!displayLoginButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: router.pathname.startsWith("/login") ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                    className: classes.signupText,
                                    variant: "body2",
                                    children: [
                                        "Don't have an account? ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                            href: "/signup",
                                            children: "Sign up"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                    className: classes.signupText,
                                    variant: "body2",
                                    children: [
                                        "Have an account? ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                            href: "/login",
                                            children: "Log in"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    container: true,
                    className: (0,clsx_m/* default */.Z)(classes.gridContainerz, classes.text),
                    justifyContent: "center",
                    alignItems: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: classes.wrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                                mdDown: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                    className: classes.logoBtn,
                                    component: Link/* Link */.r,
                                    href: !!user ? "/" : "//reclaim.ai",
                                    size: "medium",
                                    "aria-label": "reclaim.ai",
                                    disableTouchRipple: true,
                                    disableRipple: true,
                                    disableFocusRipple: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo_on_black/* default */.Z, {})
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: classes.heading,
                                variant: "h1",
                                children: "Optimize your calendar, plan a better\xa0workweek."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: classes.lighten,
                                children: "No credit card required — create a free\xa0account."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* default */.Z, {
                                dense: true,
                                className: classes.benefits,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.ZP, {
                                        disableGutters: true,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                                className: classes.checkIcon,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckRounded/* default */.Z, {
                                                    fontSize: "small"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                                disableTypography: true,
                                                children: "Save up to 40% of your workweek"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.ZP, {
                                        disableGutters: true,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                                className: classes.checkIcon,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckRounded/* default */.Z, {
                                                    fontSize: "small"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                                disableTypography: true,
                                                children: "Reduce context switching"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.ZP, {
                                        disableGutters: true,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                                className: classes.checkIcon,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckRounded/* default */.Z, {
                                                    fontSize: "small"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                                disableTypography: true,
                                                children: "Improve your weekly planning"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.ZP, {
                                        disableGutters: true,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                                className: classes.checkIcon,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckRounded/* default */.Z, {
                                                    fontSize: "small"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                                disableTypography: true,
                                                children: "Prevent unnecessary meetings"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: classes.boldText,
                                children: "Trusted by over 16,000 companies:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                className: classes.companyLogos,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/img/shopify.svg",
                                        alt: "shopify"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: classes.logoPadding,
                                        src: "/img/grafana.svg",
                                        alt: "grafana"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: classes.indeedLogo,
                                        src: "/img/indeed.svg",
                                        alt: "indeed"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/pages/signup.tsx








var signup_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, AppTheme/* WAVE.keyframes */.VZ.keyframes, AppTheme/* WAVE_DELAY.keyframes */.qB.keyframes), {
        subtitle: (0,_define_property/* default */.Z)({
            margin: "0 auto",
            padding: theme.spacing(1.75, 0, 3),
            maxWidth: 400
        }, theme.breakpoints.up("sm"), {
            maxWidth: "none"
        }),
        confetti: {
            display: "inline-block",
            fontWeight: theme.typography.fontWeightBold,
            marginLeft: theme.spacing(0.75),
            position: "relative",
            zIndex: 1,
            "&:hover span": (0,_object_spread/* default */.Z)({}, AppTheme/* WAVE.elementStyles */.VZ.elementStyles),
            "& span": (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, AppTheme/* WAVE_DELAY.elementStyles */.qB.elementStyles), {
                display: "inline-block"
            }),
            "& span:nth-child(1)": {
                animationDelay: ".3s"
            },
            "& span:nth-child(2)": {
                animationDelay: ".4s"
            },
            "& span:nth-child(3)": {
                animationDelay: ".5s"
            },
            "& span:nth-child(4)": {
                animationDelay: ".6s"
            },
            "& span:nth-child(5)": {
                animationDelay: ".7s"
            },
            "& span:nth-child(6)": {
                animationDelay: ".8s"
            },
            "& span:nth-child(7)": {
                animationDelay: ".9s"
            },
            "& span:nth-child(8)": {
                animationDelay: "1s"
            },
            "& span:nth-child(9)": {
                animationDelay: "1.1s"
            }
        }
    });
});
var Signup = function() {
    var theme = (0,useTheme/* default */.Z)();
    var classes = signup_useStyles(theme);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SignupLayout, {
        title: "Sign Up",
        displayLoginButton: true,
        officeNotice: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                component: "h1",
                variant: "h2",
                children: "Start your free trial"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                variant: "subtitle2",
                className: classes.subtitle,
                children: [
                    "Reclaim works best with your",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: classes.confetti,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "w"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "o"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "r"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "k"
                            }),
                            "\xa0",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "e"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "m"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "a"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "i"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "l"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var signup = (Signup);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6480,6886,7820,4216,9203,9774,2888,179], function() { return __webpack_exec__(47805); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);